import * as htmlToImage from 'html-to-image';

const exportAsImage = async (element, imageFileName) => {
    const html = document.getElementsByTagName("html")[0];
    const body = document.getElementsByTagName("body")[0];
    let htmlWidth = html.clientWidth;
    let bodyWidth = body.clientWidth;

    const newWidth = element.scrollWidth - element.clientWidth;

    if (newWidth > element.clientWidth) {
        htmlWidth += newWidth;
        bodyWidth += newWidth;
    }

    html.style.width = htmlWidth + "px";
    body.style.width = bodyWidth + "px";

    let dataUrl;
    if (element.querySelector('svg, canvas')) {
        const filter = (element) => {
            const exclusionClasses = ['widget-actions'];
            return !exclusionClasses.some((classname) => element.classList?.contains(classname));
        }
        dataUrl = await htmlToImage.toPng(element, {filter: filter});
    } else {
        const {default: html2canvas} = await import('~/vendor/html2canvas-1.4.1.esm.js')
        const canvas = await html2canvas(element);
        dataUrl = canvas.toDataURL("image/png", 1.0);
    }

    // download image
    const link = document.createElement('a');
    link.download = `${imageFileName}.png`;
    link.href = dataUrl;
    link.click();

    html.style.width = null;
    body.style.width = null;
};

export default exportAsImage;
